// extracted by mini-css-extract-plugin
export default {"imgContainer":"aside_imgContainer__JC7nO","aside":"aside_aside__6gqI5","help":"aside_help__wVcf7","legal":"aside_legal__pJihi"};